var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33333 9.33366H14.6667C15.4027 9.33366 16 8.73633 16 8.00033C16 7.26433 15.4027 6.66699 14.6667 6.66699H1.33333C0.597333 6.66699 0 7.26433 0 8.00033C0 8.73633 0.597333 9.33366 1.33333 9.33366Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33341 14.6667V1.33333C9.33341 0.597333 8.73608 0 8.00008 0C7.26408 0 6.66675 0.597333 6.66675 1.33333V14.6667C6.66675 15.4027 7.26408 16 8.00008 16C8.73608 16 9.33341 15.4027 9.33341 14.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus1);
export default __webpack_public_path__ + "static/media/plus1.8ea585bd6bb572ab04689d97cbfa3667.svg";
export { ForwardRef as ReactComponent };